import React, { useEffect } from 'react'

import { Box, Heading, Loading, Button, Text, Stack } from '@myxplor/stardust'

import useEnrolmentForm from '~/utils/useEnrolmentForm'
import useReEnrolmentForm from '../../utils/useReEnrolmentForm'
import SurveyRenderer from '~/components/SurveyRenderer'
import MaxWidthLayout from '~/layouts/MaxWidthLayout'
import ErrorMessage from '~/components/ErrorMessage'
import { createPrintMirrors, removePrintMirrors } from './printMirror'

const Reader = props => {
  const { serviceId, childId, guid } = props
  const isReEnrolment = !!guid
  const token = new URLSearchParams(props.location.search).get('token')
  const [enrolmentForm, getEnrolmentForm] = useEnrolmentForm()
  const [reEnrolmentForm, getReEnrolmentForm] = useReEnrolmentForm()

  useEffect(() => {
    isReEnrolment ? getReEnrolmentForm(serviceId, guid, token) : getEnrolmentForm(serviceId, childId, token)
  }, [])

  useEffect(() => {
    const handleBeforePrint = () => createPrintMirrors(document)
    const handleAfterPrint = () => removePrintMirrors(document)

    window.addEventListener('beforeprint', handleBeforePrint)
    window.addEventListener('afterprint', handleAfterPrint)

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint)
      window.removeEventListener('afterprint', handleAfterPrint)
      removePrintMirrors(document)
    }
  }, [])

  return (
    <MaxWidthLayout>
      <Box>
        <Box id="hidePrintPage" paddingY="xxsmall" width={1}>
          <Stack align="center" space="large">
            <Text fontSize="18px">{/* Childcare centre service name goes here */}</Text>

            {isReEnrolment ? (
              <Heading level={4} weight="medium">
                Viewing Completed Re-Enrolment Form
              </Heading>
            ) : (
              <Heading level={4} weight="medium">
                Viewing Completed Enrolment Form
              </Heading>
            )}
            <Heading level={5} color="mediumEmphasis" weight="medium">
              This form is Read Only, and serves as a historical record only.
            </Heading>
            <Button
              color="orange700"
              onClick={() => {
                window.print()
              }}
            >
              Print This Form
            </Button>
          </Stack>
        </Box>

        {isReEnrolment ? (
          <Box display="flex" justifyContent="center">
            {reEnrolmentForm.error && <ErrorMessage width={1 / 2}>{reEnrolmentForm.error}</ErrorMessage>}
            {!reEnrolmentForm.error && reEnrolmentForm.loading && <Loading />}
            {!reEnrolmentForm.error && reEnrolmentForm.data && (
              <SurveyRenderer
                schema={reEnrolmentForm.data.schema}
                initialData={reEnrolmentForm.data.formData}
                readOnly={true}
                singlePage={true}
                isReEnrolment={isReEnrolment}
                {...props}
              />
            )}
          </Box>
        ) : (
          <Box display="flex" justifyContent="center">
            {enrolmentForm.error && <ErrorMessage width={1 / 2}>{enrolmentForm.error}</ErrorMessage>}
            {!enrolmentForm.error && enrolmentForm.loading && <Loading />}
            {!enrolmentForm.error && enrolmentForm.data && (
              <SurveyRenderer
                schema={enrolmentForm.data.schema}
                initialData={enrolmentForm.data.formData}
                readOnly={true}
                singlePage={true}
                {...props}
              />
            )}
          </Box>
        )}
      </Box>
    </MaxWidthLayout>
  )
}

export default Reader
